import React from 'react';
import { useZitoneoServices } from '../../contexts/ZitoneoContentContext';
import ZitoneoServicesList from './zitoneoHotelServices/ZitoneoServicesList';

const HotelServices = () => {
    const {
        HotelServices: hotelServices,
        ComplementaryServiceTypes,
        selectedCategory,
        idVisibleServicesDetail,
        languages,
        handleAddService,
        handleVisibleServicesDetail,
    } = useZitoneoServices();

    return (
        <ZitoneoServicesList
            title={
                selectedCategory ? selectedCategory.Name : 'your_hotel_services'
            }
            subtitle={selectedCategory ? selectedCategory.Description : ''}
            overtitle={
                selectedCategory ? selectedCategory.Name : 'your_hotel_services'
            }
            serviceTypes={
                selectedCategory
                    ? ComplementaryServiceTypes.filter(
                          service =>
                              service.IdServiceCategory ===
                              parseInt(selectedCategory.Id)
                      )
                    : ComplementaryServiceTypes
            }
            selectedServices={hotelServices}
            selectedCategory={selectedCategory}
            onAddService={handleAddService}
            onVisibleServicesDetail={handleVisibleServicesDetail}
            idVisibleServicesDetail={idVisibleServicesDetail}
            languages={languages}
        />
    );
};

export default HotelServices;
